import api from "./axios";

export interface ProductCategoryDto {
  id: number;
  name: string;
  enabled?: boolean;
  nameKz?: string | null;
  kzReviewed?: boolean;
  folderId?: number | null;
  alStyleCategoryId?: number | null;
  configuratorSlot?: string | null;
}

export async function getCategories(folderId?: number): Promise<ProductCategoryDto[]> {
  if (folderId) {
    const res = await api.get<ProductCategoryDto[]>(`/products/folders/${folderId}/categories`);
    return res.data;
  } else {
    const res = await api.get<ProductCategoryDto[]>("/products/categories");
    return res.data;
  }
}

export async function createCategory(folderId: number, payload: Partial<ProductCategoryDto>) {
  const res = await api.post<ProductCategoryDto>(`/products/folders/${folderId}/categories`, payload);
  return res.data;
}

export async function updateCategory(id: number, payload: Partial<ProductCategoryDto>) {
  const res = await api.put<ProductCategoryDto>(`/products/categories/${id}`, payload);
  return res.data;
}

export async function deleteCategory(id: number) {
  const res = await api.delete<void>(`/products/categories/${id}`);
  return res.data;
}